<script setup>
import {Bar} from 'vue-chartjs'
import localise from "../lang/localize.json";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";
import {onMounted, ref} from "vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  }
})


const fetchdata = ref({})
const loadingApi = ref(false)

const chartData = ref()
const chartOptions = {
  responsive: true,
   indexAxis: 'y',
  plugins: {
    title: {
      display: true
    },
    legend:{
      display:false
    }
  }
}

onMounted(async () => {
  loadingApi.value = false
  try{
    
    fetchdata.value = await fetch("https://portal.thermo-control.com/API/v2/getDeliveryDelays.php?api_key=KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q&lang="+props.lang);

    let data = await fetchdata.value.json();

    loadingApi.value = true

    chartData.value = {
      labels:  '',
      datasets: [{
        label: 'Q1',
        backgroundColor: '#cbd5e1',
        data: data.q1
      },
      {
        label: 'Q2',
        backgroundColor: '#64748b',
        data: data.q2
      },
      {
        label: 'Q3',
        backgroundColor: '#a1a1aa',
        data: data.q3
      },
      {
        label: 'Q4',
        backgroundColor: '#52525b',
        data: data.q4
      },
    ]
    }

   chartOptions.plugins.legend.display = true
   chartOptions.plugins.legend.position = 'bottom'
   chartOptions.plugins.title.text = `${localise.charts_title_lastmod[props.lang]} ${data.qstand}`

  } catch (e) {
    console.error(e)
  }

})


</script>

<template>

    <figure>
      <section class="p-5 text-center block w-full text-lg animate-pulse bg-slate-100 rounded-lg"
               v-if="!loadingApi"
      >{{ localise.charts_msg_loading[lang] }}
      </section>
      <Bar v-if="loadingApi"
           id="qms-wawireg-delay-chart"
           :options="chartOptions"
           :data="chartData"
           :aria-label=localise.charts_arialabel_causedealy[props.lang]
      />

      <figcaption class="text-white text-center px-2">{{ localise.charts_arialabel_causedealy[lang] }}</figcaption>
    </figure>

</template>